import React from 'react';
import PropTypes from 'prop-types';

import { getLinkTarget } from '../../utils/getLinkTarget';

const Link = props => {
    const { children, contentState, entityKey } = props;
    const data = contentState.getEntity(entityKey).getData();
    const { url } = data;
    const linkTarget = getLinkTarget(data);

    return (
        <a href={url} target={linkTarget}>
            {children}
        </a>
    );
};

Link.propTypes = {
    children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
    contentState: PropTypes.object.isRequired,
    entityKey: PropTypes.string.isRequired
};

Link.displayName = 'Link';

export default Link;
